var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"label"},[_vm._v("Einträge pro Seite")]),_c('SelectInput',{staticClass:"dropdown",attrs:{"input-field":_vm.rowsPerPageConfig,"value":_vm.value},on:{"input":_vm.handleUpdateRowsPerPage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }